import { render } from "./SettingsNav.vue?vue&type=template&id=5c25924a&scoped=true&ts=true"
import script from "./SettingsNav.vue?vue&type=script&lang=ts"
export * from "./SettingsNav.vue?vue&type=script&lang=ts"

import "./SettingsNav.vue?vue&type=style&index=0&id=5c25924a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c25924a"]])

export default __exports__